import React, { useEffect, useState } from "react";
import {
  getAllApprovedDoctors, getAllUserTodayAppointments,
  updateAppointmentStatus,
  getDoctorAppointments,
  getHistoryOfPatient,
} from "../api/api";
import Layout from "../components/Layout";
import { useDispatch } from "react-redux";
import { hideLoading, showLoading } from "../redux/spinnerSlice";
import { Table, Input, Card, Row } from "antd";
import { Col } from "antd";
import { Button } from "antd";
import toast from "react-hot-toast";
import moment from "moment";
import DoctorList from "../components/DoctorList";
import Column from "antd/es/table/Column";

const Homepage = () => {
  const [doctors, setDoctors] = useState([]);
  const dispatch = useDispatch();
  const [appointments, setAppointments] = useState([]);
  const [allappointments, setAllAppointments] = useState([]);
  const [patientHistory, setPatientHistory] = useState([]);
  const [totalAppointments, setTotalAppointments] = useState(0);
  const [pendingAppointments, setPendingAppointments] = useState(0);
  const [approvedAppointments, setApprovedAppointments] = useState(0);
  const [totalAllTime, setTotalAllTime] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  //Get all approved doctors
  const fetchAllApprovedDoctors = async () => {
    try {
      dispatch(showLoading());
      const response = await getAllApprovedDoctors();
      setDoctors(response.data);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      console.log(err);
    }
  };
  const fetchDoctorAppointments = async () => {
    try {
      dispatch(showLoading());
      const res = await getDoctorAppointments();
      const data = res.data;
      setAllAppointments(data);
      const total = data.length;
      // const pending = data.filter(appointment => appointment.status.toUpperCase() === "PENDING").length;
      // const approved = data.filter(appointment => appointment.status.toUpperCase() === "APPROVED").length;
      setTotalAllTime(total);
      // setPendingAppointments(pending);
      // setApprovedAppointments(approved);
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      console.log(err);
    }
  };

  const fetchUserTodayAppointments = async () => {
    try {
      const response = await getAllUserTodayAppointments();
      const data = response.data; 
      setAppointments(response.data);
      const total = data.length;
      const pending = data.filter(appointment => appointment.status.toUpperCase() === "PENDING").length;
      const approved = data.filter(appointment => appointment.status.toUpperCase() === "APPROVED").length;
      setTotalAppointments(total);
      setPendingAppointments(pending);
      setApprovedAppointments(approved);
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    fetchUserTodayAppointments();
    fetchAllApprovedDoctors();
    fetchDoctorAppointments();
  }, []);
  const handleStatus = async (record, status) => {
    try {
      const appointmentsId = record._id;
      const data = { appointmentsId, status };
      dispatch(showLoading());
      const response = await updateAppointmentStatus(data);
      if (response.success) {
        toast.success(response.message);
        fetchDoctorAppointments();
      }
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };

  const handleDetails = async (record, status) => {
    try {
      const pname = record.pname;
      const data = { pname };
      dispatch(showLoading());
      const response = await getHistoryOfPatient(data);
      if (response.success) {
        toast.success(response.message);
        setPatientHistory(response.data);
        console.log(JSON.stringify(response.data));
        fetchDoctorAppointments();
      }
      dispatch(hideLoading());
    } catch (err) {
      dispatch(hideLoading());
      toast.error(err.response.data.message);
    }
  };

  const renderAppliedDate = (appliedDate) => {
    if (!appliedDate) {
      return null;
    }
    const momentDate = moment(appliedDate);
    if (!momentDate.isValid()) {
      return null;
    }
    const formattedDate =   momentDate.format('DD MMM ,YYYY');// date.toISOString().split('T')[0];
  
    return formattedDate;
  };
  const handleSearch = (e) => {
    setSearchValue(e.target.value);
  };

  const filteredAppointments = allappointments?.filter(appointment =>
    appointment.pname.toLowerCase().includes(searchValue.toLowerCase()) ||
    appointment.mobileNo.includes(searchValue)
  );
  const columns = [
    {
      title: "MR No",
      dataIndex: ["mrNo"],
      key: "mrNo",
    },
    {
      title: "Doctor Name",
      dataIndex: ["doctorInfo"],
      key: "doctorName",
      render: (doctorInfo) => `${doctorInfo?.firstName} ${doctorInfo?.lastName}`
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
    {
      title: "Patient Name",
      dataIndex: "pname",
      key: "pname",
    },
    {
      title: "Test Name",
      dataIndex: "testname",
      key: "testname",
    },
    {
      title: "Last Visit",
      dataIndex: "lastVisit",
      key: "lastVisit",
      render: renderAppliedDate,//(date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("YYYY MMM DD"),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: renderAppliedDate,// (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      // render: (time) => moment(time, "ddd MMM DD YYYY HH:mm:ss").format("hh:mm A"),
    },
    {
      title: "Appointments Type",
      dataIndex: "appoinmentType",
      key: "appoinmentType",
      render: (value) => (
        <span style={{ color: value ? "green" : "blue" }}>{value ? "Waiting" : "Confirmed"}</span>
      ),
    },

    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Button
          type={text === "APPROVE" ? "success" : text === "PENDING" ? "primary" : "default"}
          style={{
            textTransform: "uppercase",
            color: text === "pending" ? "blue" : text === "rejected" ? "red" : "green"
          }}
        >
          {text}
        </Button>
      ),
    },
    {
      title: "Actions",
      dataIndex: "actions",
      render: (text, record) => (
        <div className="d-flex">
          <button
            className="btn btn-success mx-2"
            onClick={() => handleDetails(record, "approved")}
          >
            Show History
          </button>
          {record.status === "pending" && (
            <div className="d-flex">
              <button
                className="btn btn btn-warning mx-2"
                onClick={() => handleStatus(record, "approved")}
              >
                Approved
              </button>
              <button
                className="btn btn-danger"
                onClick={() => handleStatus(record, "rejected")}
              >
                Reject
              </button>
            </div>
          )}
        </div>
      ),
    },
  ];
  const patientHistoryColumns = [
    {
      title: "MR No",
      dataIndex: ["mrNo"],
      key: "mrNo",
    },
    {
      title: "Doctor Name",
      dataIndex: ["doctorInfo"],
      key: "doctorName",
      render: (doctorInfo) => `${doctorInfo?.firstName} ${doctorInfo?.lastName}`
    },
    {
      title: "Mobile Number",
      dataIndex: "mobileNo",
      key: "mobileNo",
    },
    {
      title: "Patient Name",
      dataIndex: "pname",
      key: "pname",
    },
    {
      title: "Test Name",
      dataIndex: "testname",
      key: "testname",
    },
    {
      title: "Last Visit",
      dataIndex: "lastVisit",
      key: "lastVisit",
      render: renderAppliedDate,// (date) => moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: renderAppliedDate,//(date) => renderAppliedDate moment(date, "ddd MMM DD YYYY HH:mm:ss").format("DD MMM YYYY"),
    },
    {
      title: "Time",
      dataIndex: "time",
      key: "time",
      // render: (time) => moment(time, "ddd MMM DD YYYY HH:mm:ss").format("hh:mm A"),
    },
    {
      title: "Appointments Type",
      dataIndex: "appoinmentType",
      key: "appoinmentType",
      render: (value) => (
        <span style={{ color: value ? "green" : "blue" }}>{value ? "Waiting" : "Confirmed"}</span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => (
        <Button
          type={text === "APPROVE" ? "success" : text === "PENDING" ? "primary" : "default"}
          style={{
            textTransform: "uppercase",
            color: text === "pending" ? "blue" : text === "rejected" ? "red" : "green"
          }}
        >
          {text}
        </Button>
      ),
    },
  ];
  const hSelectDoctor = (values) => {

  }
  return (
    <>
      <Layout>

        <Row gutter={16}>
          <Col span={5}>
            <Card title={<CustomTitle></CustomTitle>} bordered={false} style={{ textAlign: "center", backgroundColor: "purple", color: 'white' }}>
              <b> <span style={{ fontSize: '50px' }}>{totalAllTime}</span> </b>
            </Card>
          </Col>
          <Col span={5}>
            <Card title={<TodayTitle></TodayTitle>} bordered={false} style={{ textAlign: "center", backgroundColor: "orange", color: 'white' }}>
              <b>  <span style={{ fontSize: '50px' }}>{totalAppointments}</span></b>
            </Card>
          </Col>
          <Col span={5}>
            <Card title={<PendingTitle></PendingTitle>} bordered={false} style={{ textAlign: "center", backgroundColor: "red", color: 'white' }}>
              <b>  <span style={{ fontSize: '50px' }}> {pendingAppointments}</span></b>
            </Card>
          </Col>
          <Col span={5}>
            <Card title={<ApproveTitle></ApproveTitle>} bordered={false} style={{ textAlign: "center", backgroundColor: "green", color: 'white' }}>
              <b> <span style={{ fontSize: '50px' }}> {approvedAppointments}</span></b>
            </Card>
          </Col>
        </Row>
        <Row gutter={16}>
          <Card title="User Appointments for Today">
            <div style={{ width: '20%', marginLeft: '80%' }}> {doctors && doctors.map((doctor) => <DoctorList key={doctor._id} doctor={doctor} handleSelectDoctor={hSelectDoctor} />)}</div>
            <br></br>
            
            <Table dataSource={appointments} columns={columns} /> {/* Render appointment data in a table */}</Card>
        </Row>
        <Row gutter={16}>

          {patientHistory.length > 0 && (
            <Card title="Patient History">
              <Table dataSource={patientHistory} columns={patientHistoryColumns} /> {/* Render appointment data in a table */}
            </Card>)}</Row>


        <Row gutter={16}>

          <Card title="Total Appointments ">


            {allappointments.length > 0 &&
              <Input
                placeholder="Search Customer"
                value={searchValue}
                onChange={handleSearch}
                style={{ marginBottom: '16px' }}
              />}
            <Table dataSource={filteredAppointments} columns={patientHistoryColumns} />
          </Card>
        </Row>
      </Layout>
    </>
  );
};
const CustomTitle = () => (
  <div style={{ color: 'white' }}>Total Appointments</div>
);
const TodayTitle = () => (
  <div style={{ color: 'white' }}>Today Total Appointments</div>
);
const PendingTitle = () => (
  <div style={{ color: 'white' }}>Today Pending Appointments</div>
);
const ApproveTitle = () => (
  <div style={{ color: 'white' }}>Today Approved Appointments</div>
);
export default Homepage;
